import React, { useState, useEffect } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'

const Update = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [errors, setErrors] = useState({}) // ✅ fix: use object not null
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [oldImage, setOldImage] = useState(null)
    const [page, setPage] = useState({ value: '', error: false })
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

    // Handle image
    const handleImage = event => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 1000) {
                setErrors(prev => ({ ...prev, image: 'Select less than 1000KB file.' }))
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })
            setErrors(prev => ({ ...prev, image: null }))
        }
    }

    // Submit Form
    const onSubmit = async (event) => {
        event.preventDefault()
        if (!page.value) return setPage({ ...page, error: true })
        if (!selectedFile) return setErrors(prev => ({ ...prev, image: 'Image is required' }))

        let formData = new FormData()
        formData.append('page', page.value)
        formData.append('image', selectedFile.image)

        try {
            setLoading(true)
            await Requests.Addsense.Update(id, formData, header)
            navigate("/dashboard/marketing/web-ad")
        } catch (err) {
            console.error(err)
            setErrors(prev => ({ ...prev, submit: 'Failed to update. Try again.' }))
        } finally {
            setLoading(false)
        }
    }

    // get user by id 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await Requests.Addsense.GetById(id, header)
                setPage(prev => ({ ...prev, value: result.page }))
                setOldImage(result.addsenseImage)
            } catch (err) {
                console.error(err)
                setErrors(prev => ({ ...prev, fetch: 'Failed to fetch data.' }))
            }
        }
        fetchData()
    }, [id, header])

    return (
        <div className="store-addsense pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <h6 className="mb-0">Update Addsense</h6>
                                    <Link
                                        to="/dashboard/marketing/web-ad"
                                        className="btn shadow-none rounded-circle"
                                    >
                                        <Icon icon={chevronLeft} size={22} />
                                    </Link>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={onSubmit}>

                                    {/* page */}
                                    <div className="form-group mb-4">
                                        {page.error ? <p className="text-danger">Page is required.</p> : <p>Select page</p>}
                                        <select
                                            className="form-control shadow-none"
                                            value={page.value} // ✅ controlled input
                                            onChange={event => setPage({ value: event.target.value, error: false })}
                                        >
                                            <option value="">-- Select Page --</option>
                                            <option value="clientDashboard">Client Dashboard (260px * auto)</option>
                                            <option value="adminDashboard">Admin Dashboard</option>
                                            <option value="gotokDashboard">Gotok Dashboard</option>
                                        </select>
                                    </div>

                                    {/* Image upload Container */}
                                    <div className="form-group mb-4">
                                        {errors.image && <p className="text-danger">{errors.image}</p>}
                                        <p>Image</p>
                                        <div className="d-flex">
                                            {selectedFile?.preview ? (
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={selectedFile.preview} className="img-fluid" alt="preview" />
                                                    </div>
                                                </div>
                                            ) : oldImage ? (
                                                <div className="img-container text-center mr-2">
                                                    <div className="image border">
                                                        <img src={oldImage} className="img-fluid" alt="old" />
                                                    </div>
                                                </div>
                                            ) : null}

                                            <div className="img-container text-center">
                                                <div className="image-plus border">
                                                    <input type="file" className="upload" onChange={handleImage} />
                                                    <div className="flex-center flex-column">
                                                        <Icon icon={plus} size={22} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {errors.submit && <p className="text-danger">{errors.submit}</p>}
                                    {errors.fetch && <p className="text-danger">{errors.fetch}</p>}

                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Submitting...' : 'Submit'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Update
